import React from 'react';

import { Widget } from '@typeform/embed-react';
import step_1 from '../resources/landing_page/step_1.png';
import step_2 from '../resources/landing_page/step_2.png';
import step_3 from '../resources/landing_page/step_3.png';
import step_4 from '../resources/landing_page/step_4.png';

function LandingPage() {

  return (
    <div className="landing-page">

      <div className="row container mb-5">

        <div className="col-sm-12 offset-md-2 col-md-8">
          <span className="landing-tagline text-center">Access structured data from <span className="relative whitespace-nowrap text-blue"><svg aria-hidden="true" viewBox="0 0 418 42" className="absolute top-2/3 h-[0.58em] w-full fill-blue-300/70" preserveAspectRatio="none"><path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z"></path></svg><span className="relative">any source</span></span></span>
 
          <p className="row welcome-title mt-5">Welcome to Sourcelift</p>
          <p className="row welcome-body">We're here to give you access to the data you need, in the format you require, without having to hire a data engineering team to source and prepare it.</p>

          <div className="mt-4 text-center">

            {/* 
            <button className="btn btn-primary col-xl-3 col-md-12 fw-bold p-2 mt-2 mb-2 text" data-bs-toggle="collapse" data-bs-target="#typeform" aria-expanded="false" aria-controls="typeform">Book a call</button>
            */}
            <a className="btn btn-primary col-xl-3 col-md-12 fw-bold p-2 mt-2 mb-2 text" href="https://8ptby2lmwa9.typeform.com/to/UHCt2G8B" target="_blank" rel="noreferrer">Book a call</a>


          </div>

          <div className="collapse" id="typeform">
            <Widget className="typeform" id="UHCt2G8B" />
          </div>
          

          <br />
          <br />
        </div>


      </div>

      <div className="landing-page-how mt-5" id="how-it-works">
        <div className="row container">
          <span className="landing-how-tagline">Streamline your data acquisition experience.</span>
          <p className="mt-5">
            Use Sourcelift to identify data you need from unstructured sources, and receive the data in a structured format that's useful to your team. 
            Our engineers will build the scrapers and pipelines you need to receive high quality data at a fraction of a cost of building in house solutions.
          </p>
        </div>

        <div className="row container mt-5">
          <div className="card">
            <img className="card-img-top" src={step_1} alt="step1"/>
            <div className="card-body">
              <h5 className="card-title">Describe your data usecase</h5>
              <p className="card-text">Tell us about your use case so we can understand what you need the data for. This will inform how we structure it.</p>
            </div>
          </div>

          <div className="card">
            <img className="card-img-top" src={step_2} alt="step2"/>
            <div className="card-body">
              <h5 className="card-title">Indicate desired data sources</h5>
              <p className="card-text">Browse our data marketplace for commonly requested structure datasets. If you don't see what you need, tell us and we'll fix it for you.</p>
            </div>
          </div>

          <div className="card">
            <img className="card-img-top" src={step_3} alt="step3"/>
            <div className="card-body">
              <h5 className="card-title">Receive data in structured format</h5>
              <p className="card-text">Download data dumps or use our streaming API to access the data you need for backfill, realtime queries, ML model training and more.</p>
            </div>
          </div>

          <div className="card">
            <img className="card-img-top" src={step_4} alt="step4"/>
            <div className="card-body">
              <h5 className="card-title">Profit</h5>
              <p className="card-text">$$$</p>
            </div>
          </div>
        </div>
      </div>


      <div className="landing-page-pricing" id="pricing">
        <div className="row container">
          <span className="landing-pricing-tagline">Complex pricing, questionable value.</span>
          <p className="mt-2 text-lg text-center text-slate">Gain access to the data you need today.</p>
        </div>

        <div className="row mt-5 container">


        
        <div class="card">
          <span class="card-top-pricing display-6 fw-bold text-start ms-3 mt-5">From $1</span>
          <span class="text-start fw-light ms-3">per 10 records</span>
          <div class="card-body">
            <h5 class="card-title text-start">Point-In-Time Datasets</h5>
            <p class="card-text">First 100 records free</p>
            <a class="btn btn-card col-12 fw-bold p-2 mt-3 mb-3" href="https://8ptby2lmwa9.typeform.com/to/UHCt2G8B" target="_blank" rel="noreferrer">Book a call</a>
            <ul class="mt-5 mb-5 ms-3 pricing-card-list">
                <li className="text-start"><span>No credit card needed to view the sample data</span></li>
                <li className="text-start"><span>Recieve data in .csv, .sql, or .json format</span></li>
                <li className="text-start"><span>High quality data for training and fine-tuning</span></li>
            </ul>
          </div>
        </div>
        
        <div class="card">
          <span class="card-top-pricing display-6 fw-bold text-start ms-3 mt-5">From $15</span>
          <span class="text-start fw-light ms-3">billed monthly</span>
          <div class="card-body">
            <h5 class="card-title text-start">Incrementally Updated Datasets</h5>
            <p class="card-text">Free for 7 days, and then $15/month</p>
            <a class="btn btn-card col-12 fw-bold p-2 mt-3 mb-3" href="https://8ptby2lmwa9.typeform.com/to/UHCt2G8B" target="_blank" rel="noreferrer">Book a call</a>
            <ul class="mt-5 mb-5 ms-3 pricing-card-list">
              <li className="text-start"><span>No credit card needed to try it out</span></li>
              <li className="text-start"><span>Recieve streamed, incremental updates to any dataset we offer</span></li>
            </ul>
          </div>
        </div>

        



        </div>
      </div>


      <footer className="footer">
          <div className="row container">
            <span className="copyright">© 2024 Sourcelift all rights reserved</span>
          </div>
      </footer>


    </div>
  );
}

export default LandingPage;
